import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import AssociationAvatars from './AssociationAvatars';
import PriorityBadge from './PriorityBadge';
import { jsx as _jsx } from "react/jsx-runtime";
const Footer = ({
  subject,
  primaryAssociationDefinition,
  secondaryAssociationDefinition,
  getAssociationData
}) => {
  return /*#__PURE__*/_jsx(MediaObject, {
    itemRight: /*#__PURE__*/_jsx(PriorityBadge, {
      subject: subject
    }),
    align: "center",
    children: /*#__PURE__*/_jsx(AssociationAvatars, {
      subject: subject,
      primaryAssociationDefinition: primaryAssociationDefinition,
      secondaryAssociationDefinition: secondaryAssociationDefinition,
      getAssociationData: getAssociationData
    })
  });
};
export default Footer;